import * as React from "react";
const SvgVoice = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3.75, y: 9, width: 1.5, height: 6, rx: 0.75, fill: "currentColor", fillOpacity: 0.4, style: {
  fill: "currentColor",
  fillOpacity: 0.4
} }), /* @__PURE__ */ React.createElement("rect", { x: 6.75, y: 6, width: 1.5, height: 12, rx: 0.75, fill: "currentColor", fillOpacity: 0.4, style: {
  fill: "currentColor",
  fillOpacity: 0.4
} }), /* @__PURE__ */ React.createElement("rect", { x: 9.75, y: 3, width: 1.5, height: 18, rx: 0.75, fill: "currentColor", fillOpacity: 0.4, style: {
  fill: "currentColor",
  fillOpacity: 0.4
} }), /* @__PURE__ */ React.createElement("rect", { x: 12.75, y: 9, width: 1.5, height: 6, rx: 0.75, fill: "currentColor", fillOpacity: 0.4, style: {
  fill: "currentColor",
  fillOpacity: 0.4
} }), /* @__PURE__ */ React.createElement("rect", { x: 15.75, y: 6, width: 1.5, height: 12, rx: 0.75, fill: "currentColor", fillOpacity: 0.4, style: {
  fill: "currentColor",
  fillOpacity: 0.4
} }), /* @__PURE__ */ React.createElement("rect", { x: 18.75, y: 9, width: 1.5, height: 6, rx: 0.75, fill: "currentColor", fillOpacity: 0.4, style: {
  fill: "currentColor",
  fillOpacity: 0.4
} }));
export default SvgVoice;
